<template>
  <div class="inline">
    <spinner :visible="isLoading > 0" :overlay="true"></spinner>
    <v-modal id="modal-whitelist-activities" class="modal-xl">
      <span class="align-left" slot="header"> Gestione BOM Paziente </span>

      <div class="inline" slot="footer">
        <button v-if="!blockBomSend" @click="doSync()" class="primary q-ml-xs">
          <span class="fa fa-download q-mr-xs"></span>
          Scarica BOM paziente
        </button>
        <button v-if="superUser" class="primary q-ml-xs" :disabled="!isFormValid" @click="saveWhitelistedActivities()">
          <span class="fa fa-upload q-mr-xs"></span>
          {{ blockBomSend ? 'Salva BOM paziente' : 'Invia BOM paziente' }}
        </button>
      </div>

      <div class="container-flex">
        <div class="content content-filters-and-errors">
          <div class="content-item" v-if="errorsShow">
            <div class="errors-box">
              <p v-for="error in errors" :key="error.message">
                {{ error.message }}
              </p>
            </div>
          </div>
          <div class="content-item" v-if="successShow">
            <div class="success-box">
              <p>Operazione andata a buon fine</p>
            </div>
          </div>
        </div>

        <div class="content">
          <!-- Sezione Sinistra: Selezione Attività -->
          <div class="content-item">
            <p>BOM contratto</p>
            <div class="filters-table">
              <div class="form-group">
                <label for="area-selector in">Trattamento</label>
                <select v-model="selectedArea">
                  <option v-for="area in areasForSelect" :key="area.id" :value="area">
                    {{ area.description }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <div>
                  <input class="filter-search-table" name="filter-table-selector" placeholder="Cerca nella tabella" v-model="searchTerm" />
                </div>
              </div>
            </div>
            <div v-if="selectedArea">
              <h4>{{ selectedArea.description }}</h4>
              <table class="table table-hover table-striped">
                <thead>
                  <tr class="heading">
                    <th>Descrizione</th>
                    <th class="fit">
                      <a class="fa fa-chevrons-right text-danger" @click="onSelectedAllActivities(selectedArea)"></a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="activity in filteredActivitiesForTable" :key="activity.id">
                    <td>
                      {{ activity.description }}
                    </td>
                    <td class="fit">
                      <a class="fa fa-chevron-right text-danger" @click="onSelectActivity(activity, selectedArea)"></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Sezione Destra: Aree e Attività Selezionate -->
          <div class="content-item">
            <p>BOM paziente</p>
            <div>
              <label>Mostra tutto</label>
              <input type="checkbox" v-model="showAllTreatments" />
            </div>
            <div :class="'treatment treatment' + area.external_status" v-for="area in filterWhitelistedActivities()" :key="area.id">
              <div class="padding-1">
                <h4>{{ area.description }}</h4>
                <div class="area-dates">
                  <div>
                    <label>Dal:</label>
                    <input
                      type="date"
                      v-model="area.datein"
                      :class="{ 'input-error': !isValidDate(area.datein) || isAreaFromBeforeStartPeriod(area.datein) }"
                    />
                  </div>
                  <div v-if="area.external_status !== 2 && area.external_status !== 3">
                    <label>Al:</label>
                    <input
                      type="date"
                      v-model="area.dateout"
                      :disabled="isValidStatus(area.external_status)"
                      :class="{ 'input-error': !isValidDate(area.dateout) || !isFromBeforeTo(area.datein, area.dateout) }"
                    />
                  </div>
                  <div>
                    <label>Stato:</label>
                    <select v-model="area.external_status" id="statusSelect">
                      <option v-for="status in statuses" :key="status.id" :value="status.id">
                        {{ status.description }}
                      </option>
                    </select>
                  </div>
                </div>
                <table class="table table-hover table-striped">
                  <thead>
                    <tr class="heading">
                      <th class="fit">
                        <a class="fa fa-chevrons-left text-danger" @click="onUnselectAllActivities(area)"></a>
                      </th>
                      <th>Descrizione</th>
                      <th>Frequenza</th>
                      <th>Quantità</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="activity in area.activities" :key="activity.id">
                      <td class="fit">
                        <a class="fa fa fa-chevron-left text-danger text-danger" @click="onUnselectActivity(activity, area)"></a>
                      </td>
                      <td>
                        {{ activity.description }}
                      </td>
                      <td>
                        <input
                          class="input-mini"
                          type="number"
                          :class="{ 'input-error': activity.frequency == null }"
                          v-model="activity.frequency"
                        />
                      </td>
                      <td>
                        <input
                          class="input-mini"
                          type="number"
                          :class="{ 'input-error': activity.quantity == null }"
                          v-model="activity.quantity"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-modal>
  </div>
</template>

<script>
import vModal from '../vModal';
import spinner from '../spinner';
import apiConnector from '@/epersonam/apiConnector';

export default {
  name: 'whitelistActivities',
  components: {
    vModal,
    spinner,
  },
  props: {
    guestBusinessUnitId: {
      type: Number,
      required: true,
    },
    guestPeriodDataSetId: {
      type: Number,
      required: true,
    },
    startPeriod: {
      type: String,
      required: true,
    },
    superUser: {
      type: Boolean,
      required: true,
    },
    blockBomSend: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      baseUrl: window.config.ePersonamService.ePersonamHost + '/' + window.locale,

      areasForSelect: [],
      selectedArea: null,

      activitiesForTable: [],
      searchTerm: null,

      whitelistedActivities: [],

      successShow: false,
      errorsShow: false,
      errors: [],

      isLoading: 0,
      sync: false,

      showAllTreatments: false,

      statuses: [
        { id: 0, description: 'ACT' },
        { id: 1, description: 'SUSP' },
        { id: 2, description: 'DEACT' },
        { id: 3, description: 'OLD' },
      ],
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    areaUrl() {
      return (
        this.baseUrl +
        '/activities_configs.json?page=null&type=area&sintesi=true&skip_sintesi=true&guest_business_unit_id=' +
        this.guestBusinessUnitId
      );
    },
    activityUrl() {
      const url =
        this.baseUrl +
        '/activities_configs.json?page=null&type=activity&skip_sintesi=true&guest_business_unit_id=' +
        this.guestBusinessUnitId;
      return Utils.addGetParam(url, 'area_id', this.selectedArea.id);
    },
    whitelistedActivityUrl() {
      return this.baseUrl + '/guest_period_data_sets/' + this.guestPeriodDataSetId + '/guest_activity_whitelists.json';
    },
    whitelistActivitiesUpdateUrl() {
      return this.baseUrl + '/guest_period_data_sets/' + this.guestPeriodDataSetId + '/guest_activity_whitelists/bulk_update.json';
    },

    unselectedActivitiesForTable() {
      return this.activitiesForTable.filter((obj) => !this.whitelistedActivitiesMap[obj.id]);
    },
    filteredActivitiesForTable() {
      if (this.searchTerm) {
        return this.unselectedActivitiesForTable.filter((obj) => obj.description.toLowerCase().includes(this.searchTerm.toLowerCase()));
      } else {
        return this.unselectedActivitiesForTable;
      }
    },
    whitelistedActivitiesMap() {
      const map = {};

      this.whitelistedActivities.forEach((area) => {
        area.activities.forEach((activity) => {
          map[activity.id] = activity;
        });
      });

      return map;
    },
    isFormValid() {
      return this.isActivitiesValid() && this.isAreasValid();
    },
  },
  async mounted() {
    console.log('Mounted modal BOM items');
    console.log(window.locale);
    this.loadAreasForSelect();
    await this.loadWhitelistedActivities();

    $('#modal-whitelist-activities')
      .modal('show')
      .on('hidden.bs.modal', () => {
        this.$emit('modalClosed', true);
      });
  },
  watch: {
    selectedArea() {
      this.loadActivitiesByArea();
    },
  },
  methods: {
    doSync() {
      this.sync = true;
      this.loadWhitelistedActivities();
      this.sync = false;
    },
    prepareCall() {
      this.isLoading++;
      this.successShow = false;
      this.errorsShow = false;
      this.errors = [];
    },
    isValidStatus(status) {
      return status === 2 || status === 3;
    },
    isValidDate(date) {
      return moment(date).isValid();
    },
    isFromBeforeTo(datein, dateout) {
      return new Date(datein) <= new Date(dateout);
    },
    isActivitiesValid() {
      return this.whitelistedActivities.every((area) =>
        area.activities.every((activity) => activity.frequency !== null && activity.quantity !== null),
      );
    },
    isAreasValid() {
      let isValid = this.whitelistedActivities.every((area) => !this.isAreaFromBeforeStartPeriod(area.datein));

      if (!isValid) {
        this.errorsShow = true;
        this.errors = [
          { message: `La data di inizio trattamento dev'essere successiva alla data di ingresso del paziente. (${this.startPeriod})` },
        ];
      } else {
        this.errorsShow = false;
        this.errors = [];
      }

      return isValid;
    },
    isAreaFromBeforeStartPeriod(datein) {
      const startPeriod = moment(this.startPeriod, 'DD/MM/YYYY');
      const dateinFormatted = moment(datein, 'YYYY-MM-DD');

      return startPeriod.isValid() && dateinFormatted.isBefore(startPeriod);
    },
    filterWhitelistedActivities() {
      if (this.showAllTreatments) {
        return this.whitelistedActivities;
      } else {
        return this.whitelistedActivities.filter((area) => area.external_status !== 2);
      }
    },
    onSelectActivity(activity, area) {
      let whitelistedArea = this.whitelistedActivities.find((el) => el.id === area.id);
      this.whitelistedActivities = [...this.whitelistedActivities];

      if (!whitelistedArea) {
        whitelistedArea = {
          ...area,
          datein: null,
          dateout: null,
          external_status: 0,
          activities: [],
        };
        this.whitelistedActivities.push(whitelistedArea);
      }

      const activityToWhitelist = {
        ...activity,
        quantity: null,
        frequency: null,
      };

      const isAlreadyPresentActivity = whitelistedArea.activities.find((el) => el.id === activity.id);
      if (!isAlreadyPresentActivity) {
        whitelistedArea.activities.push(activityToWhitelist);
      }
    },

    onSelectedAllActivities(area) {
      this.activitiesForTable.forEach((activity) => {
        this.onSelectActivity(activity, area);
      });
    },

    onUnselectActivity(activity, area) {
      const whitelistedArea = this.whitelistedActivities.find((ele) => ele.id === area.id);

      const whitelistedActivities = [...whitelistedArea.activities];
      const index = whitelistedActivities.indexOf(activity);

      if (index > -1) {
        whitelistedActivities.splice(index, 1);
      }

      const dup = [...this.whitelistedActivities];
      const areaIdx = this.whitelistedActivities.indexOf(whitelistedArea);
      if (whitelistedActivities.length === 0) {
        dup.splice(areaIdx, 1);
      } else {
        dup[areaIdx].activities = whitelistedActivities;
      }
      this.whitelistedActivities = dup;
    },

    onUnselectAllActivities(area) {
      const areaIdx = this.whitelistedActivities.indexOf(area);
      this.whitelistedActivities.splice(areaIdx, 1);
      this.whitelistedActivities = [...this.whitelistedActivities];
    },

    async loadAreasForSelect() {
      this.prepareCall();

      try {
        const { data } = await apiConnector().get(this.areaUrl);

        this.areasForSelect = data.map((obj) => ({
          description: obj.description,
          sintesi_id: obj.sintesi_id,
          id: obj.id,
        }));
      } catch (e) {
        console.error('Could not load areas for select');
        console.error(e);
      } finally {
        this.isLoading--;
      }
    },

    async loadActivitiesByArea() {
      this.prepareCall();

      try {
        const { data } = await apiConnector().get(this.activityUrl);

        this.activitiesForTable = data.map((obj) => ({
          description: obj.description,
          sintesi_id: obj.sintesi_id,
          id: obj.id,
          areaId: obj.area_id,
        }));
      } catch (e) {
        console.error('Could not load activities for selected area for select');
        console.error(e);
      } finally {
        this.isLoading--;
      }
    },

    async loadWhitelistedActivities() {
      this.prepareCall();

      try {
        const { data } = await apiConnector().get(this.whitelistedActivityUrl, { params: { sync: this.sync } });

        this.whitelistedActivities = data.map((obj) => ({
          description: obj.description,
          id: obj.id,
          datein: obj.datein,
          dateout: obj.dateout,
          sintesi_id: obj.sintesi_id,
          external_status: obj.external_status,
          activities: obj.activities.map((obj) => ({
            id: obj.id,
            sintesi_id: obj.sintesi_id,
            description: obj.description,
            frequency: obj.frequency,
            quantity: obj.quantity,
          })),
        }));
      } catch (e) {
        console.error('Could not load whitelisted activities');
        console.error(e);
      } finally {
        this.isLoading--;
      }
    },

    async saveWhitelistedActivities() {
      this.prepareCall();

      if (!this.isFormValid) {
        return false;
      }

      // Svuota dateout per status OLD (3) o DEACT (2)
      const dataToSend = this.whitelistedActivities.map((area) => ({
        ...area,
        dateout: this.isValidStatus(area.external_status) ? null : area.dateout,
      }));

      try {
        const res = await apiConnector().post(this.whitelistActivitiesUpdateUrl, {
          whitelisted_areas: dataToSend,
        });

        if (res.status === 200) {
          this.successShow = true;
        } else {
          this.errorsShow = true;
          this.errors = res.errors;
        }
      } catch (e) {
        console.error('Error on save the whitelist areas and activities');
        console.error(e);

        this.errorsShow = true;
        this.errors = e.response.data.errors;
      } finally {
        this.isLoading--;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background: white;
}

label {
  display: inline;
  margin-right: 5px;
}

.title {
  text-align: left;
}

.inline {
  display: inline-block;
}

.modal-xl {
  width: 80%;
  margin-left: 0;
  left: 10%;
}

.container-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.filters {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px;

  .filter {
    flex: 1;
  }
}

.filters-table {
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
}

.content-item {
  flex: 1;
  margin: 0 5px;
  text-align: center;
}

/* Optional: Responsiveness */
@media (max-width: 768px) {
  .content {
    flex-direction: column;
    align-items: center;
  }

  .content-item {
    margin: 10px 0;
    width: 80%;
  }
}

.form-group {
  margin-bottom: 15px;
}

.area-dates {
  display: flex; /* Abilita il flexbox */
  justify-content: space-between; /* Spazia gli elementi orizzontalmente */
}

.treatment {
  border-radius: 5px;
  margin: 3px 0;

  &.treatment0 {
    background-color: rgba(39, 174, 96, 0.3);
  }

  &.treatment1 {
    background-color: rgba(255, 255, 76, 0.3);
  }

  &.treatment2 {
    background-color: rgba(216, 17, 0, 0.4);
  }

  &.treatment3 {
    background-color: rgba(231, 76, 60, 0.3);
  }
}

.input[type='text'] {
  width: 100%;
  height: 40px;
  line-height: 28px;
  padding: 0 1rem;
  padding-left: 2.5rem;
  border: 2px solid transparent;
  border-radius: 8px;
  outline: none;
  background-color: #f3f3f4;
  color: #0d0c22;
  transition: 0.3s ease;
}

.input[type='text']::placeholder {
  color: #9e9ea7;
}

.padding-1 {
  padding: 10px;
}

.input[type='text']:focus,
input:hover {
  outline: none;
  border-color: rgba(234, 76, 137, 0.4);
  background-color: #fff;
  box-shadow: 0 0 0 4px rgb(234 76 137 / 10%);
}

.icon {
  position: absolute;
  left: 1rem;
  fill: #9e9ea7;
  width: 1rem;
  height: 1rem;
}

.input-mini {
  width: 50px;
}

td,
th {
  vertical-align: middle;

  &.right {
    text-align: right !important;
    padding-right: 25px;
  }
}

#statusSelect {
  height: 34px;
}

.filter-search-table {
  padding: 0 2.5px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  border-radius: 4px;
  vertical-align: middle;
}

#spinnerwrap {
  z-index: 1100;
}

input,
.input-mini {
  padding: 0 2.5px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  border-radius: 4px;
  vertical-align: middle;

  &.input-error {
    border-color: #e74c3c;
  }
}

.errors-box {
  padding: 15px 10px;
  text-align: left;
  background-color: #f08080;
  border-radius: 5px;
  color: #22223b;
  margin-bottom: 10px;
}

.success-box {
  padding: 15px 10px;
  text-align: left;
  background-color: #27ae60;
  border-radius: 5px;
  color: #22223b;
  margin-bottom: 10px;
}
</style>
